module.exports = __webpack_public_path__ + "static/logo-e14539e2d06a3c65f185dd6cedfc509a.png";